import * as React from "react";
import { TRenderable } from "source/app/presentation/Shared/SharedTypes";
import { StyleClass } from 'source/app/presentation/Shared/Styles/CSS';

export function ShowSurvivalGuideLabel({
    survivalGuideLabel,
}: {
    survivalGuideLabel: TRenderable;
}) {
    return (
        <span
            className={centerElement2DStyleClass}
            style={{
                fontSize: "14px",
                maxWidth: "200px",
                textAlign: "center",
                zIndex: 3,
            }}
        >
            <div>{survivalGuideLabel}</div>
        </span>
    );
}

const centerElement2DStyleClass = StyleClass(
    `centerElement2DStyleClass`,
    {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    }
);
